import { Flex, Table, Tbody, Td, Th, Thead, Tr, Typography } from '@aloft/toolkit-sui';

import { AdjustmentSettingsHelperText } from '../../../components/AdjustmentSettingsHelperText.tsx';

export const CommentaryTable = ({
  data,
  helperText,
  footnote,
}: {
  data: [string[], ...Array<string | string[]>[]];
  helperText?: string;
  footnote?: string;
}) => {
  const [headers, ...rows] = data;

  return (
    <Flex flexDirection="column" gap={1} overflowX="auto">
      <Table className="commentary-table">
        <Thead>
          <Tr>
            {headers.map((header, idx) => (
              <Th key={`${header}-${idx}`}>
                <Typography variant="h5">{header}</Typography>
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((row, rowIndex) => (
            <Tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <Td key={`${rowIndex}${cellIndex}${cell}`}>
                  {Array.isArray(cell)
                    ? cell.map((c, i) => (
                        <Typography key={i} variant="body2">
                          {c}
                        </Typography>
                      ))
                    : cell}
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
      {helperText && <AdjustmentSettingsHelperText helperText={helperText} />}
      {footnote && <Typography variant="body2">{footnote}</Typography>}
    </Flex>
  );
};
